export const CONTINENT_KEYS = [
  "africa",
  "antarctica",
  "asia",
  "europe",
  "northAmerica",
  "oceania",
  "southAmerica",
] as const;

export type ContinentKey = (typeof CONTINENT_KEYS)[number];

export const CONTINENT_BY_ISO_NUM: Record<string, ContinentKey> = {
  "004": "asia",
  "008": "europe",
  "010": "antarctica",
  "012": "africa",
  "024": "africa",
  "031": "asia",
  "032": "southAmerica",
  "036": "oceania",
  "040": "europe",
  "044": "northAmerica",
  "050": "asia",
  "051": "asia",
  "056": "europe",
  "064": "asia",
  "068": "southAmerica",
  "070": "europe",
  "072": "africa",
  "076": "southAmerica",
  "084": "northAmerica",
  "090": "oceania",
  "096": "asia",
  "100": "europe",
  "104": "asia",
  "108": "africa",
  "112": "europe",
  "116": "asia",
  "120": "africa",
  "124": "northAmerica",
  "140": "africa",
  "144": "asia",
  "148": "africa",
  "152": "southAmerica",
  "156": "asia",
  "158": "asia",
  "170": "southAmerica",
  "178": "africa",
  "180": "africa",
  "188": "northAmerica",
  "191": "europe",
  "192": "northAmerica",
  "196": "asia",
  "203": "europe",
  "204": "africa",
  "208": "europe",
  "214": "northAmerica",
  "218": "southAmerica",
  "222": "northAmerica",
  "226": "africa",
  "231": "africa",
  "232": "africa",
  "233": "europe",
  "238": "southAmerica",
  "242": "oceania",
  "246": "europe",
  "250": "europe",
  "260": "antarctica",
  "262": "africa",
  "266": "africa",
  "268": "asia",
  "270": "africa",
  "275": "asia",
  "276": "europe",
  "288": "africa",
  "300": "europe",
  "304": "northAmerica",
  "320": "northAmerica",
  "324": "africa",
  "328": "southAmerica",
  "332": "northAmerica",
  "340": "northAmerica",
  "348": "europe",
  "352": "europe",
  "356": "asia",
  "360": "asia",
  "364": "asia",
  "368": "asia",
  "372": "europe",
  "376": "asia",
  "380": "europe",
  "384": "africa",
  "388": "northAmerica",
  "392": "asia",
  "398": "asia",
  "400": "asia",
  "404": "africa",
  "408": "asia",
  "410": "asia",
  "414": "asia",
  "417": "asia",
  "418": "asia",
  "422": "asia",
  "426": "africa",
  "428": "europe",
  "430": "africa",
  "434": "africa",
  "440": "europe",
  "442": "europe",
  "450": "africa",
  "454": "africa",
  "458": "asia",
  "466": "africa",
  "478": "africa",
  "484": "northAmerica",
  "496": "asia",
  "498": "europe",
  "499": "europe",
  "504": "africa",
  "508": "africa",
  "512": "asia",
  "516": "africa",
  "524": "asia",
  "528": "europe",
  "540": "oceania",
  "548": "oceania",
  "554": "oceania",
  "558": "northAmerica",
  "562": "africa",
  "566": "africa",
  "578": "europe",
  "586": "asia",
  "591": "northAmerica",
  "598": "oceania",
  "600": "southAmerica",
  "604": "southAmerica",
  "608": "asia",
  "616": "europe",
  "620": "europe",
  "624": "africa",
  "626": "asia",
  "630": "northAmerica",
  "634": "asia",
  "642": "europe",
  "643": "europe",
  "646": "africa",
  "682": "asia",
  "686": "africa",
  "688": "europe",
  "694": "africa",
  "703": "europe",
  "704": "asia",
  "705": "europe",
  "706": "africa",
  "710": "africa",
  "716": "africa",
  "724": "europe",
  "728": "africa",
  "729": "africa",
  "732": "africa",
  "740": "southAmerica",
  "748": "africa",
  "752": "europe",
  "756": "europe",
  "760": "asia",
  "762": "asia",
  "764": "asia",
  "768": "africa",
  "780": "northAmerica",
  "784": "asia",
  "788": "africa",
  "792": "asia",
  "795": "asia",
  "800": "africa",
  "804": "europe",
  "807": "europe",
  "818": "africa",
  "826": "europe",
  "834": "africa",
  "840": "northAmerica",
  "854": "africa",
  "858": "southAmerica",
  "860": "asia",
  "862": "southAmerica",
  "887": "asia",
  "894": "africa",
};

export const CONTINENT_BY_NAME_FALLBACK: Record<string, ContinentKey> = {
  "N. Cyprus": "asia",
  Somaliland: "africa",
  Kosovo: "europe",
};

export const PLACE_KEYS = [
  "chelseaPiers",
  "clermontNational",
  "greenwichPeninsula",
  "wexhamPark",
  "siheungSaltbay",
  "ulsanGalaxia",
  "incheonGolf24",
  "daejeonHanmireu",
  "seoulChoiResearch",
  "icheonMidasLake",
  "banpoRangeX",
  "saitamaFlags",
  "zhongliWaitou1",
  "newTaipeiWaitou2",
] as const;
export type PlaceKey = (typeof PLACE_KEYS)[number];

export const ACTIVE_CONTINENT_KEYS = [
  "asia",
  "europe",
  "northAmerica",
] as const satisfies readonly ContinentKey[];
export type ActiveContinentKey = (typeof ACTIVE_CONTINENT_KEYS)[number];

export const DEFAULT_SELECTED_CONTINENT: ActiveContinentKey = "asia";

export type ContinentMeta = {
  coordinates: [number, number];
  places: readonly PlaceKey[];
};

// 한국 마커 좌표 (반도 중심부)
export const KOREA_MARKER_COORDS: [number, number] = [127.7, 36.5];

export const KOREA_PLACE_KEYS = [
  "siheungSaltbay",
  "ulsanGalaxia",
  "incheonGolf24",
  "daejeonHanmireu",
  "seoulChoiResearch",
  "icheonMidasLake",
  "banpoRangeX",
] as const satisfies readonly PlaceKey[];

// 지도 핀 표시용 좌표 [위도, 경도]. 도시 단위 근사값 — 월드맵 핀 위치로 충분.
// (주의: react-simple-maps <Marker> 는 [경도, 위도] 순서를 받으므로 사용처에서 뒤집을 것)
export const PLACE_COORDINATES: Record<PlaceKey, [number, number]> = {
  chelseaPiers: [40.7506, -74.0084],
  clermontNational: [28.5494, -81.7729],
  greenwichPeninsula: [51.5006, 0.005],
  wexhamPark: [51.54, -0.6],
  siheungSaltbay: [37.3804, 126.803],
  ulsanGalaxia: [35.5384, 129.3114],
  incheonGolf24: [37.4563, 126.7052],
  daejeonHanmireu: [36.3504, 127.3845],
  seoulChoiResearch: [37.5665, 126.978],
  icheonMidasLake: [37.2724, 127.435],
  banpoRangeX: [37.504, 127.005],
  saitamaFlags: [35.9715, 139.6357],
  zhongliWaitou1: [24.9536, 121.2253],
  newTaipeiWaitou2: [25.0123, 121.465],
};

// 지점별 Google Maps 공유 링크(maps.app.goo.gl). 링크 미제공 지점은 UI 에서 지도 아이콘을 숨김.
export const PLACE_MAPS_URL: Partial<Record<PlaceKey, string>> = {
  seoulChoiResearch: "https://maps.app.goo.gl/GtQ6LpAWSs8RRZHJ7",
  siheungSaltbay: "https://maps.app.goo.gl/PRjExDGNW3FKRb9F7",
  ulsanGalaxia: "https://maps.app.goo.gl/Wd6m4rUyt82gkSCQ8",
  incheonGolf24: "https://maps.app.goo.gl/krS13esLkBeEs1qD6",
  daejeonHanmireu: "https://maps.app.goo.gl/gsaXLKoVggdLsPAL9",
  icheonMidasLake: "https://maps.app.goo.gl/SNhoWFudzVj2SgnN6",
  banpoRangeX: "https://maps.app.goo.gl/MQds1spuQRsoApzZ8",
  newTaipeiWaitou2: "https://maps.app.goo.gl/rCfJTbDibzMkRh1k9",
  zhongliWaitou1: "https://maps.app.goo.gl/yyDZcvBoZreujmkm7",
  greenwichPeninsula: "https://maps.app.goo.gl/Vhcx6FPWP7Jvfy3T9",
  wexhamPark: "https://maps.app.goo.gl/2QNZ6w2ooGJrz3DMA",
  chelseaPiers: "https://maps.app.goo.gl/yewNA4AVN4L7U4Z3A",
  clermontNational: "https://maps.app.goo.gl/GpULj5prRJBVP4hUA",
  saitamaFlags: "https://maps.app.goo.gl/dYwiFcYx74CQqYkCA",
};

// 설치 장소 카드 노출 순서 — 기획 시트(2026-07-29 전달 이미지) 기준.
// 해외(미국 → 영국 → 일본 → 대만) 뒤에 한국 지점이 온다. 대륙 그룹 순서와 다르므로
// 대륙 flatMap 이 아니라 이 배열이 "전체" 탭의 단일 출처다.
export const APEX_DISPLAY_ORDER = [
  "chelseaPiers",
  "clermontNational",
  "greenwichPeninsula",
  "wexhamPark",
  "saitamaFlags",
  "zhongliWaitou1",
  "newTaipeiWaitou2",
  "daejeonHanmireu",
  "icheonMidasLake",
  "siheungSaltbay",
  "seoulChoiResearch",
  "banpoRangeX",
  "incheonGolf24",
  "ulsanGalaxia",
] as const satisfies readonly PlaceKey[];

export const APEX_CONTINENTS: Record<ActiveContinentKey, ContinentMeta> = {
  asia: {
    coordinates: [110, 35],
    places: [
      "siheungSaltbay",
      "ulsanGalaxia",
      "incheonGolf24",
      "daejeonHanmireu",
      "seoulChoiResearch",
      "icheonMidasLake",
      "banpoRangeX",
      "saitamaFlags",
      "zhongliWaitou1",
      "newTaipeiWaitou2",
    ],
  },
  europe: {
    coordinates: [10, 50],
    places: ["greenwichPeninsula", "wexhamPark"],
  },
  northAmerica: {
    coordinates: [-95, 40],
    places: ["chelseaPiers", "clermontNational"],
  },
};
